<template>
  <v-dialog :value="value"
            width="500">
    <h6 :class="$modals.modalTitle">
      <slot />
    </h6>
    <div :class="$modals.modalButtons">
      <app-button
        text="Cancel"
        button-style="default"
        :class="$modals.modalBtn"
        @click="closeDialog($event)"
      />
      <app-button
        text="Delete"
        button-style="accent"
        :class="$modals.modalBtn"
        @click="deleteItem($event)"
      />
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    deleteItem(e) {
      this.$emit('delete', e);
    },
    closeDialog(e) {
      this.$emit('close', e);
    },
  },
};
</script>

<style src="@/styles/modals.scss" lang="scss" module="$modals"></style>
